export enum ProfileType {
  SUPERIOR_AC = 0,
  SUPERIOR_TIME = 1,
  WORKER_AC = 2,
  WORKER_TIME = 3,
  ADMINISTRATOR_AC = 4,
  AGENT = 5,
  RECEPTION = 6,
  PFSO = 8,
  SHIFT_DIRECTOR = 9,
  SECURITY = 10,
  EMPLOYEE = 11,
  OHS = 12,
  OPERATIONAL_SUPPORT = 13,
}
